export enum ConfigTypeEnum {
	WIRE_GRID = 'wg',
	PARTICLE_BOARD = 'pb',
	STEEL_PERF = 'st'
}
